import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

export const fmt = (v, dec = 1) =>
  v.toLocaleString("it-IT", { minimumFractionDigits: dec, maximumFractionDigits: dec });

export const Rv = ({ d = 0, y = 28, className, children, ...p }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, filter: "blur(10px)" }}
    animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    transition={{ delay: d, duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
    {...p}
  >
    {children}
  </motion.div>
);

export function Counter({ to, from = 0, dec = 1, delay = 0, dur = 1800, testid }) {
  const [v, setV] = useState(from);
  useEffect(() => {
    let raf;
    const t0 = performance.now() + delay;
    const tick = (now) => {
      const p = Math.min(1, Math.max(0, (now - t0) / dur));
      setV(from + (to - from) * (1 - Math.pow(1 - p, 4)));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [to, from, delay, dur]);
  return <span data-testid={testid}>{fmt(v, dec)}</span>;
}

export const Kicker = ({ n, children }) => (
  <Rv d={0.1}>
    <div className="kicker"><span className="kicker-n">{n}</span>{children}</div>
  </Rv>
);

export const Source = ({ children }) => (
  <Rv d={1.6} y={0} className="source">Fonte · {children}</Rv>
);

export function TiltCard({ children, base = "", d = 0, testid, className = "" }) {
  const ref = useRef();
  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    ref.current.style.transform = `${base} rotateY(${x * 16}deg) rotateX(${-y * 12}deg)`;
  };
  const onLeave = () => { ref.current.style.transform = base; };
  return (
    <Rv d={d} y={60} className="tilt-outer">
      <div ref={ref} className={`tilt glass ${className}`} style={{ transform: base }} onMouseMove={onMove} onMouseLeave={onLeave} data-testid={testid}>
        {children}
      </div>
    </Rv>
  );
}

export const HBar = ({ label, value, max, d, color, testid }) => (
  <div className="hbar" data-testid={testid}>
    <div className="hbar-top"><span>{label}</span><b><Counter to={value} delay={d * 1000} /> <small>mld m³</small></b></div>
    <div className="hbar-track">
      <motion.div className="hbar-fill" style={{ background: color }} initial={{ width: 0 }} animate={{ width: `${(value / max) * 100}%` }} transition={{ delay: d, duration: 1.6, ease: [0.2, 0.8, 0.2, 1] }} />
    </div>
  </div>
);
